import React from 'react'
import '../guia-de-estilos.css'

const Formularios = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Formulario</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6'>
              <div className='py-3'>
                <form class="row g-3">
                  <div class="col-md-6">
                    <label for="inputEmail4" class="amc-label">Correo</label>
                    <input type="email" class="form-control" id="inputEmail4"/>
                  </div>
                  <div class="col-md-6">
                    <label for="inputPassword4" class="amc-label">Password</label>
                    <input type="password" class="form-control" id="inputPassword4"/>
                  </div>
                  <div class="col-12">
                    <label for="inputAddress" class="amc-label">Dirección</label>
                    <input type="text" class="form-control" id="inputAddress" placeholder=""/>
                  </div>
                  <div class="col-12">
                    <label for="inputAddress2" class="amc-label">Dirección 2</label>
                    <input type="text" class="form-control" id="inputAddress2" placeholder=""/>
                  </div>
                  <div class="col-md-6">
                    <label for="inputCity" class="amc-label">Ciudad</label>
                    <input type="text" class="form-control" id="inputCity"/>
                  </div>
                  <div class="col-md-4">
                    <label for="inputState" class="amc-label">Estado</label>
                    <select id="inputState" class="form-select">
                      <option selected>...</option>
                      <option>...</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label for="inputZip" class="amc-label">C.P.</label>
                    <input type="text" class="form-control" id="inputZip"/>
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="gridCheck"/>
                      <label class="form-check-label" for="gridCheck">
                        Seleccionar
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <button type="" class="btn-amc-ch btn-amc-pink">Enviar</button>
                  </div>
                </form>
              </div>
            </div>
            <div className='col-12 col-md-4'>
              <div className='p-3'>
                <div class="form-check form-switch form-check-reverse">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckReverse"></input>
                  <label class="form-check-label" for="flexSwitchCheckReverse">Switch checkbox</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Formularios